import React from 'react';

import useBreakpoint from '../../shared/hooks/use-breakpoint/useBreakpoint';
import useFeatureToggle from '../../shared/hooks/use-feature-toggle/useFeatureToggle';
import { FeatureToggle, IconPack, ToolbarContent } from '../../shared/models/app-data-model';
import GlobalTool from '../global-tool/global-tool';
import './global-toolbar-section.scss';

export type GlobalToolbarSectionProps = {
  content: ToolbarContent[];
  featureToggles: FeatureToggle[];
  iconPack: IconPack[];
  className: string;
};

const GlobalToolbarSection: React.FC<GlobalToolbarSectionProps> = ({
  content,
  className,
  featureToggles,
  iconPack
}: GlobalToolbarSectionProps) => {
  const breakpoint = useBreakpoint();
  const locationEnabled = useFeatureToggle('global-toolbar-location', featureToggles);
  const filteredContent = content?.filter(function (tool: ToolbarContent) {
    const toolType = tool?.tool_settings?.tool_content?.onclick_behavior[0]?.internal?.type;
    const displayMobile = tool?.tool_settings?.mobile_settings?.show_in_mobile;
    if ((toolType === 'sh_location_prompt' && !locationEnabled) || (breakpoint === 0 && displayMobile)) {
      return;
    }
    return tool;
  });

  return (
    <ul className={className}>
      {filteredContent?.map((tool: ToolbarContent, index: number) => (
        <GlobalTool key={index} content={tool} iconPack={iconPack} featureToggles={featureToggles} />
      ))}
    </ul>
  );
};

export default GlobalToolbarSection;
